<section id="sign-in">
  <div class="container">
    <img src="../../../../assets/img/logo@3x.png" />

    <form name="form" (ngSubmit)="f.form.valid && login(verificationCode)" #f="ngForm">
      <mat-form-field>
        <input
          matInput
          placeholder="Code"
          i18n-placeholder="@@verification-code"
          name="verificationCode"
          [(ngModel)]="verificationCode"
          required
        />
      </mat-form-field>

      <button matButton="filled" [disabled]="loading$ | async">
        <span i18n="2fa page|login label">LOGIN</span>
        @if (loading$ | async) {
        <mat-spinner diameter="18" class="spinner"></mat-spinner>
        }
      </button>
      <button matButton="filled" [disabled]="counter !== 0" (click)="resendCode()" class="resend-btn">
        <span i18n="@@resend-code">Resend</span> {{ counter | date: 'm:ss' }}
      </button>
      <div class="errorMsg">{{ (error$ | async)?.message | humanize }}</div>
    </form>
  </div>
</section>
